export const getResumeActivationCta = ({ isAuthenticated = false } = {}) => ({
  eyebrow: "Activación de suscripción",
  title: isAuthenticated
    ? "Retoma la activación de tu cuenta"
    : "Entra para retomar tu activación",
  description:
    "Dashboard y Mi Cuenta te llevan al mismo flujo para activar, reactivar o revisar el estado exacto de tu suscripción.",
  buttonLabel: isAuthenticated ? "Ir a Mi Cuenta" : "Iniciar sesión para activar",
  href: isAuthenticated ? "/account?tab=subscription" : "/login",
});